
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/waianapanapa/faq",
      function () {
        return require("private-next-pages/waianapanapa/faq.js");
      }
    ]);
  